unable to read source [project]/frontend/node_modules/src/ui/scanner/file-selection-ui.ts